var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"ui-upload-img",attrs:{"accept":"image/*","type":"file","multiple":_vm.isMultiple},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }